import Axios from 'axios';
import { apiUrl } from 'app/environment-variables';
import { FooterLinksI } from './models.d';

export const getFooterLinks = () =>
  Axios.get<CommonTypes.RestfulResponse<FooterLinksI>>(`${apiUrl}/page-links`);
